import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { MicrosoftAuthService } from 'src/app/shared/services/microsoft-auth.service';

@Component({
  selector: 'app-microsoft-callback',
  templateUrl: './microsoft-callback.component.html',
  styleUrls: [
    '../authentication/authentication.component.scss',
    './microsoft-callback.component.scss'
  ]
})
export class MicrosoftCallbackComponent implements OnInit {
  processing = true;
  errorMessage: string | null = null;
  private returnUrl: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private microsoftAuthService: MicrosoftAuthService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<void> {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl')
      || this.microsoftAuthService.consumeReturnUrl();
    const outcome = await this.microsoftAuthService.handleRedirectCallback();

    if (outcome === 'success') {
      await this.router.navigateByUrl(this.returnUrl || `/${AppConstants.ROUTES.HOME}`);
      return;
    }

    if (outcome === 'rejected') {
      this.processing = false;
      this.errorMessage = this.microsoftAuthService.getLastErrorMessage() || 'Microsoft login was rejected.';
      this.cdr.detectChanges();
      return;
    }

    await this.router.navigateByUrl(this.returnUrl || `/${AppConstants.ROUTES.HOME}`);
  }

  async retryMicrosoftLogin(): Promise<void> {
    this.processing = true;
    this.errorMessage = null;
    await this.microsoftAuthService.loginWithRedirect(this.returnUrl || undefined);
  }

  goToManualLogin(): void {
    this.router.navigate(
      [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN],
      { queryParams: { returnUrl: this.returnUrl || `/${AppConstants.ROUTES.HOME}` } }
    );
  }
}
